import styled from 'styled-components';
import {
    backgroundColor,
    backgroundColorActive,
    modalBoxShadow,
    primaryText,
    secondaryText,
} from 'styles/theme';

export const GlobalSearchContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 50000;
`;

export const GlobalSearchContent = styled.div`
    background: ${backgroundColor};
    border: solid 1px transparent;
    box-shadow: ${modalBoxShadow};
    box-sizing: border-box;
    width: 60vw;
    min-width: 40rem;
    max-height: 90vh;
    margin: 5vh auto 0 auto;
    padding: 0.75rem;
    overflow-y: auto;
`;

export const SearchResults = styled.div<{ $isLoading: boolean }>`
    position: relative;
    min-height: ${({ $isLoading }) => ($isLoading ? '4rem' : 0)};
`;

export const NoResults = styled.div`
    color: ${secondaryText};
    padding: 1rem;
`;

export const SearchTargetContainer = styled.div<{ $isHighlighted: boolean }>`
    cursor: pointer;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
    padding: 0.5rem 0;
    color: ${primaryText};
    text-decoration: none;
    background: ${({ $isHighlighted }) =>
        $isHighlighted ? backgroundColorActive : 'transparent'};

    &:hover {
        background: ${backgroundColorActive};
    }
`;

export const SearchTargetName = styled.div`
    font-size: 16px;
    font-weight: 500;
`;

export const SearchTargetPathContainer = styled.div`
    color: ${primaryText};
    font-size: 14px;
    font-style: italic;
`;

export const PathSeparator = styled.span`
    color: ${secondaryText};
    margin: 0 0.25rem;
`;

export const TargetIconContainer = styled.div<{ $color: string }>`
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${({ $color }) => $color};
    color: var(--foreground-inverse);
    border-radius: 100%;
    width: 3rem;
    height: 3rem;
    font-size: 12px;
`;
